import { UPDATE_BY_LINE_ID } from 'revamp-mutations';

export default {
    namespaced: true,
    actions: {
        billUpdated({ commit }, rowData) {
            commit(`revamp/table/${UPDATE_BY_LINE_ID}`, rowData, { root: true });
        },
    },
};
